import * as React from 'react'
import { ScrollView, Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import * as IncidentStore from '@store/incident/incident'
import useReducer from '@store/useReducer'

import useI18n from '@i18n/useI18n'

interface Props {
  items: IncidentStepScreen[]
  selected: IncidentStepScreen
  onItemSelected: (idx: IncidentStepScreen) => void
}

const BLACKLIST = ['START']
const TRANSFORM: Record<string, IncidentStepScreen> = { ACTIVITY_DETAIL: 'ACTIVITY' }

const Timeline = ({ items, selected, onItemSelected }: Props) => {
  const i18n = useI18n()

  const completed = useReducer(IncidentStore.store, (s) => s.form.completed)

  // remove split from every level of activity
  const current = TRANSFORM[selected] || selected

  // current page index
  const selectedIdx = items.findIndex((it) => it === current)

  // remove unused screens
  const data = items.filter((it) => !BLACKLIST.includes(it))

  const renderItem = (item: IncidentStepScreen, index: number, list: IncidentStepScreen[]) => {
    if (item === current) {
      return (
        <React.Fragment key={item}>
          <DescriptionItem>
            <ItemText active={false}>{`${index + 1} - ${i18n.t(`screens.incident.${item}.step`)}`}</ItemText>
          </DescriptionItem>

          {index != list.length - 1 && <Separator />}
        </React.Fragment>
      )
    }

    const active = index < selectedIdx || completed

    return (
      <React.Fragment key={item}>
        <Item active={active} disabled={!active} activeOpacity={0.8} key={item} onPress={() => onItemSelected(item)}>
          <ItemText active={active}>{index + 1}</ItemText>
        </Item>

        {index != data.length - 1 && <Separator />}
      </React.Fragment>
    )
  }

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }}>
      {data.map(renderItem)}
    </ScrollView>
  )
}

export default Timeline

const Item = styled(TouchableOpacity)<{ active: boolean }>`
  background-color: ${(props) => (props.active ? props.theme.colors.primary : props.theme.colors.backgroundSecondary)};
  border: 2px solid ${(props) => props.theme.colors.primary};
  height: 50px;
  width: 50px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
`

const DescriptionItem = styled(TouchableOpacity)`
  background-color: ${(props) => props.theme.colors.backgroundSecondary};
  border: 2px solid ${(props) => props.theme.colors.primary};
  height: 50px;
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  padding: 0 25px;
`

const ItemText = styled(Text)<{ active: boolean }>`
  ${(props) => props.theme.fonts.Headline};
  color: ${(props) => (props.active ? props.theme.colors.background : props.theme.colors.primary)};
`

const Separator = styled(View)`
  background-color: ${(props) => props.theme.colors.primary};
  height: 2px;
  min-width: 5px;
  max-width: 50px;
  flex: 1;
  align-self: center;
`
